import { memo, type FC } from "react";
import type { Clip } from "@src/features/clips/types/clip";
import { ClipPreviewCard } from "@src/features/clips/components";

interface ClipCardProps {
  clip: Clip;
  onPress: () => void;
  timezone: string;
}

export const ClipCard: FC<ClipCardProps> = memo(({ clip, onPress, timezone }) => {
  return <ClipPreviewCard clip={clip} onPress={onPress} timezone={timezone} />;
});
